define('boxes/reality-check-popup/dialog',['jquery', 'all/dialog'],

	function ($, dialog) {
		'use strict';

		/* public api of this module */
		function create(uiEventHandlers) {
			/**
			 *
			 * @type {module:boxes/controllers/box-controllers.BoxController}
			 */
			var FLOW_GET_REALITY_CHECK_SESSION_INFO = 'PlayerRealityCheckPopupInfo',
				api = {},
				properties = {};


			// Model
			function getPopupData() {
				var deferred = $.Deferred();

				$.ajax('/pp?flow=' + FLOW_GET_REALITY_CHECK_SESSION_INFO)
				.done(function (data) {
					deferred.resolve(data);
				})
				.fail(function (jqXhr, text) {
					deferred.reject(text);
				});
				return deferred.promise();
			}

			function addEventHandler(handlerDescriptor) {
				var el;
				if (this && this.querySelector) {
					el = this.querySelector(handlerDescriptor.selector);
					if (el && el.addEventListener) {
						el.addEventListener(handlerDescriptor.event, handlerDescriptor.handler, false);
						el = null;
					}
				}
			}

			function removeEventHandler(handlerDescriptor) {
				var el;
				if (this && this.querySelector) {
					el = this.querySelector(handlerDescriptor.selector);
					if (el && el.removeEventListener) {
						el.removeEventListener(handlerDescriptor.event, handlerDescriptor.handler, false);
						el = null;
					}
				}
			}


			/**
			 * [this] bound to $dialogDiv
			 */
			function addPopupEventHandlers() {
				uiEventHandlers.forEach(addEventHandler, this.get(0));
			}

			/*
			 * [this] bound to $dialogDiv
			 */
			function removePopupEventHandlers() {
				uiEventHandlers.forEach(removeEventHandler, this.get(0));
			}

			function showPopup() {
				// View
				dialog.flow('PlayerRealityCheckPopupInfo', {}, addPopupEventHandlers, removePopupEventHandlers, undefined);

			}

			function showErrorPopup(error) {
				alert('failed loading Reality Check Popup Info Data: ' + error);
			}


			/*
			 * Public API
			 */
			function showDialog() {
				// $.when(getPopupData()).then(showPopup, showErrorPopup);
				showPopup();

			}

			function closeDialog() {
				dialog.close(FLOW_GET_REALITY_CHECK_SESSION_INFO);
			}

			api.showDialog = showDialog;
			api.closeDialog = closeDialog;

			return Object.create(api, properties);
		}

		return {
			create: create
		};

	}
);

